var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7 9H9l1.95-6.3L12.9 9h6.3l-5.1 3.9 1.95 6.3-5.1-3.9-5.1 3.9 1.95-6.3L2.7 9Zm53.55-9L0 33.75V45h3.75L60 11.25V0h-3.75Z",
    fill: "#F7D618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0 0 36v9L60 9V0Z",
    fill: "#CE1021"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogFlag);
export default __webpack_public_path__ + "static/media/cog-flag.951f7fa3d8b8157644a4d5e03f4f5423.svg";
export { ForwardRef as ReactComponent };